/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SCPropertyAddressFormatter = (cellContent, row, rowIndex) => {
  const { scAddress } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {scAddress ? scAddress : `-`}
      </div>
      <> </>
    </>
  );
};
